"use client";

import { rpc } from "#rpc";
import { ArticleCard } from "@/components/ui/ArticleCard";
import type { BlokArticlePage } from "@/storyblok";

import { useUrlSearchParams } from "@frend-digital/ui/next";
import { keepPreviousData, useQuery } from "@tanstack/react-query";
import React, { useContext } from "react";
import type { ISbStoryData } from "storyblok-js-client";
import styles from "./ArticleListingPage.module.css";
import { SegmentControlContext } from "@/components/SegmentControl/SegmentControl";
export const ArticleListingPageClient = ({
	initialStories,
	language,
}: {
	initialStories: ISbStoryData<BlokArticlePage>[];
	language: string;
}) => {
	const selectedTags = useUrlSearchParams().getAll("tag");

	const { data: stories } = useQuery({
		queryKey: ["article-listing-page", selectedTags],
		queryFn: async () => {
			return rpc.stories.getArticleListingPages(language, selectedTags);
		},
		initialData: initialStories,
		placeholderData: keepPreviousData,
	});

	const { segments } = useContext(SegmentControlContext);

	let filteredStories =
		selectedTags.length > 0
			? stories.filter((article) =>
					article.tag_list?.some((tag) =>
						selectedTags.some((selectedTag) => tag.toLowerCase() === selectedTag.toLowerCase()),
					),
				)
			: stories;

	if (segments && Object.keys(segments).length > 0) {
		filteredStories = filteredStories.filter((article) => {
			const articleCountries = (article.content as { countries?: string[] }).countries;

			if (!articleCountries || !Array.isArray(articleCountries) || articleCountries.length === 0) {
				return true;
			}

			const currentCountry = segments.countries;

			return typeof currentCountry === "string" && articleCountries.includes(currentCountry);
		});
	}
	return (
		<>
			{filteredStories.map((article) => {
				if (!article.content.listingTitle) return null;
				return (
					<ArticleCard
						key={article.uuid}
						image={article.content.listingImage}
						title={article.content.listingTitle}
						description={article.content.listingDescription}
						className={styles.item}
						tags={article.tag_list}
						slug={article.full_slug}
					/>
				);
			})}
		</>
	);
};
